export enum ProblemStatus {
  WAITING = 1,
  FIXED,
  CANCELLED
}
